<template>
	<transition name="fade">
		<div v-if="isOpen" class="modal">
			<div class="modal-content">
				<slot name="body"></slot>
			</div>

			<div class="overlay"></div>
		</div>
	</transition>
</template>

<script>
import { watch } from '@vue/runtime-core'
// import { ref } from '@vue/reactivity'
export default {
	props: {
		isOpen: {
			default: false
		}
	},

	setup(props) {
		watch(
			() => props.isOpen,
			(value) => {
				if (value) {
					document.body.style.overflow = 'hidden'
				} else {
					document.body.style.overflow = 'auto'
				}
			}
		)
		return {
			// isOpen
		}
	}
}
</script>

<style lang="scss" scoped>
.modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.5rem;

	&-content {
		background-color: #fff;
		width: 100%;
		border-radius: 1.5rem;
		position: relative;
		z-index: 10;
		padding: 25px 20px;
		max-width: 400px;
		margin-left: auto;
		margin-right: auto;
	}
}

.overlay {
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 8;
	position: absolute;
	left: 0;
	top: 0;
}
</style>
